import { gql } from '@apollo/client';

export const HOST_INPUT_FR = gql`
  fragment HostData on HostOverview {
    group_id
    alias
  }
`;
